module.exports = __webpack_public_path__ + "img/winerackdog24.b70aaaf8.jpg";